import {AppStateNameEnum} from '@core/enums/app-state-name.enum';
import {Action, createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';
import * as fromActions from './consent-use-case-actions';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';
import {UnitARequestModel} from '@core/modules/rest/consent/request/unit-a-request.model';

export const REDUCER_NAME = AppStateNameEnum.feature_consent_use_case_basic;

export interface State {
    consentUseCases: ConsentUseCaseBasicModel[];
    useCasesChapterUnits: ConsentUseCaseBasicModel[];
    chapterUnits: UnitARequestModel[];
    loading: boolean;
}

const initialState: State = {
    consentUseCases: [],
    useCasesChapterUnits: [],
    chapterUnits: null,
    loading: false
};

const stateSelector = createFeatureSelector<State>(REDUCER_NAME);

export const consentUseCaseSelector = createSelector(stateSelector, (state: State) => state.consentUseCases);
export const loadingSelector = createSelector(stateSelector, (state: State) => state.loading);

const innerReducer = createReducer(
    initialState,
    on(fromActions.GetConsentUseCases, ((state: State): State => ({
        ...state
    }))),
    on(fromActions.GetConsentUseCasesSuccess, ((state: State, {consentUseCases}): State => ({
        ...state,
        consentUseCases
    }))),
    on(fromActions.SetConsentChapterDetails, ((state: State, {chapterUseCases }): State => ({
        ...state,
        chapterUnits: chapterUseCases,
        loading: false
    }))),
);

export function consentChapterReducer(state: State | undefined, action: Action): State {
    return innerReducer(state, action);
}
